/* src/app/common/components/order-status/order-progress-bar.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=order-progress-bar.component.css.map */
